<template>
  <div class="app-config-container">
    <PageHeader :title="$t('message.mobile.common.appConfiguration')" />
    <v-tabs v-model="tab" slider-color="primary" class="tabs">
      <v-tab
        v-for="item in items"
        :key="item.tab"
        :ripple="false"
        class="tabs__item"
        :disabled="item.disabled"
      >
        <component :is="item.icon" />{{ item.tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="tabs__items">
      <v-tab-item v-for="item in items" :key="item.tab">
        <component :is="item.component"></component>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import PageHeader from "@/components/ui/PageHeader.vue";
import GooglePlayAccountsList from "@/components/GooglePlay/GooglePlayAccountsList.vue";
import GooglePlayIcon from "@/components/ui/Icons/GooglePlayIcon.vue";

export default {
  name: "AccountsList",
  components: {
    PageHeader,
    GooglePlayAccountsList,
    GooglePlayIcon
  },
  data() {
    return {
      tab: null,
      items: [
        {
          tab: "Google Play",
          icon: "GooglePlayIcon",
          component: "GooglePlayAccountsList",
          disabled: false
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.content {
  > * + * {
    margin-top: $spacing * 3;
  }
}

.app-config-container {
  padding: $spacing * 3;
}

.tabs {
  position: relative;
  z-index: 1;
  margin-top: $spacing * 2.5;

  ::v-deep * {
    overflow: visible !important;
  }

  ::v-deep .v-tabs-bar {
    background: transparent;
  }

  ::v-deep .v-tabs-slider-wrapper {
    display: none;
  }

  ::v-deep .v-slide-group__wrapper {
    contain: unset;
  }

  &__filters {
    display: flex;
    justify-content: flex-end;
    padding: 0 $spacing * 2;
    margin-bottom: $spacing * 3;
    margin-top: $spacing;
    gap: $spacing;
  }

  &__item {
    text-transform: unset;
    letter-spacing: unset;
    @include font-size(12px);
    font-weight: 600;
    padding: $spacing * 1.5 $spacing * 3;
    background: $gray-800;
    border-radius: 8px 8px 0 0;
    &:before {
      border-radius: 8px 8px 0 0;
    }
    &:not(.v-tab--active) {
      color: $grey-darker !important;
    }
    &.v-tab--active {
      background: white;
      overflow: hidden;
      &:before {
        display: none;
      }
      &:after {
        border-radius: 8px 8px 0 0;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        box-shadow: 0px -20px 20px rgba(54, 60, 86, 0.07);
        position: absolute;
        z-index: -10;
      }
    }
  }

  svg {
    margin-right: $spacing;
  }

  &__items {
    box-shadow: 0px 20px 20px rgba(54, 60, 86, 0.07);
    border-radius: 0 24px 24px 24px;
  }
}
</style>
